module.exports = __webpack_public_path__ + "static/img/lb4.c27457d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lb4.png
// module id = wTfO
// module chunks = 1